import React from 'react';
import { Row, Col } from 'reactstrap';

import Radio from 'src/componentes/radio';
import AcaoLookup from 'src/lookups/acao';
import { capitalizeFirstLetter } from 'src/utils/string';

export function TipoCadastroAcaoRow({
  modoVincularAcao,
  tipoCadastroOptions,
  ehAcaoVinculada,
  registroPreenchido,
  intl,
  onTipoCadastroChange,
}) {
  return (
    <Row className="align-items-center mb-0">
      <Col xs="auto" className="form-group">
        <span
          style={{
            color: '#71717a',
            fontSize: 16,
            fontWeight: 600,
          }}
        >
          {capitalizeFirstLetter(intl.formatMessage({ id: 'tipoCadastro' }))}
        </span>
      </Col>
      <Col>
        <Radio
          needId
          showLabel={false}
          inline
          optionLabelStyle={{ marginBottom: 0, display: 'flex' }}
          disabled={ehAcaoVinculada || registroPreenchido}
          model={{
            value: modoVincularAcao ? 'vincular' : 'nova',
            requestChange: onTipoCadastroChange,
          }}
          options={tipoCadastroOptions}
          labelField="descricao"
          idField="id"
        />
      </Col>
    </Row>
  );
}

function VincularAcaoForm({
  model,
  intl,
  resources,
  editarAcaoOrigem,
  ehAcaoVinculada,
  itemId,
  onConfirmarAcaoVinculada,
}) {
  const acaoOrigemModel = model.getModel('acaoOrigem');
  const itemDestinoId = itemId ?? model.getModel('item')?.value?.id;

  const handleAcaoOrigemChange = (acao) => {
    acaoOrigemModel.requestChange(acao);
    if (acao) {
      onConfirmarAcaoVinculada(acao, itemDestinoId);
    }
  };

  return (
    <Row style={{ paddingBottom: '13rem' }}>
      <Col md={12}>
        <AcaoLookup
          required
          disabled={!editarAcaoOrigem || ehAcaoVinculada}
          model={{
            label: capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'label.acaoOrigem' },
                { acao: resources.acao }
              )
            ),
            value: acaoOrigemModel.value,
            requestChange: handleAcaoOrigemChange,
            errors: acaoOrigemModel.errors,
          }}
          data={{
            filtrarAcoesVinculadas: true,
            itemIdIgnorar: itemDestinoId,
          }}
        />
      </Col>
    </Row>
  );
}

export default VincularAcaoForm;
